import { createFileRoute } from '@tanstack/react-router'

import { CustomersScreen } from '@/features/customers/customers-screen'
import { customersSearchSchema } from '@/features/customers/customers-search'

/** The customers list, its tab, search, sort and page in the address. */
export const Route = createFileRoute('/_app/_org/customers/')({
  validateSearch: customersSearchSchema,
  component: CustomersScreen,
})
